<template>
  <li v-if="all_sections !== undefined && !all_sections.sections_exclude.includes(section)" class="m-menu__item" :class="[{'m-menu__item--submenu' : submenu }, { 'm-menu__item--active': active }, {'m-menu__item--open': openMenu}]" aria-haspopup="true"  :data-menu-submenu-toggle="(submenu) ? 'hover' : 'toggle'">
    <a v-if="submenu" href="" class="m-menu__link m-menu__toggle">
      <i class="m-menu__link-icon" :class="icon"></i>
      <span class="m-menu__link-text">
        {{ name | translate | titleize }}
      </span>
      <i class="m-menu__ver-arrow la la-angle-right" v-if="submenu" ></i>
		</a>
    <router-link v-else :to="link" class="m-menu__link m-menu__toggle">
      <i class="m-menu__link-icon" :class="icon"></i>
      <span class="m-menu__link-text">
        {{ name | translate | titleize }}
      </span>
      <i class="m-menu__ver-arrow la la-angle-right" v-if="submenu" ></i>
		</router-link>
    <div class="m-menu__submenu" :style="showSubmenu" v-if="submenu">
		  <span class="m-menu__arrow"></span>
			<slot name="submenu"></slot>
		</div>
  </li>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  props: {
    active: { type: String, required: false },
    icon: { type: String, required: true },
    link: { type: String, required: true },
    name: { type: String, required: true },
    submenu: { type: Boolean, required: false },
    index: { type: Number, required: true },
    modal: { type: String, required: false },
    section: { type: String, required: true }
  },
  computed: {
    ...mapGetters({all_sections: 'allSections'}),
    openMenu () {
      var response = ''
      for (let i = 0; i < this.all_sections.children[this.section].length; i++) {
        const element = this.all_sections.children[this.section][i]
        if (element.route === this.$route.path) {
          response = true
          break
        } else {
          response = false
        }
      }
      return response
    },
    showSubmenu () {
      var response = ''
      for (let i = 0; i < this.all_sections.children[this.section].length; i++) {
        const element = this.all_sections.children[this.section][i]
        if (element.route === this.$route.path) {
          response = 'display: block;'
          break
        } else {
          response = 'display: none;'
        }
      }
      return response
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Menu.vue